export default "__VITE_ASSET__DmfczN$v__"